const initialState = {
  item: {
    isNewSharedFolder: false,
    name: null,
    description: null,
  },
};

export default initialState;
